/* eslint-disable import/prefer-default-export */
import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { DocumentSummary } from "./Models";

type AnswerRequest = {
  itemNumberId: number;
  question: string;
  recaptchaToken: string;
};

type AnswerResponse = {
  interactionKey: string;
  message: string;
  answer: {
    errorMessage: string;
    relevantDocuments: DocumentSummary[];
    response: string;
    unanswered: boolean;
  };
};

type ErrorResponse = {
  message?: string;
  title?: string;
  errors?: {
    $?: string[];
  };
};

async function getErrorFromResponse(response: Response): Promise<Error> {
  let errorMessage;
  let errorDetail;
  try {
    const responseContent = await response.json<ErrorResponse>();
    errorMessage =
      responseContent?.message ?? responseContent?.title ?? "unknown";
    errorDetail = responseContent?.errors?.$?.join("; ") ?? "";
  } catch {
    errorMessage = "unknown";
    errorDetail = "";
  }

  return new Error(
    `Fetch for /chatbot/ask failed with status ${response.status} - ${errorMessage}`,
    { cause: `message: ${errorMessage}; detail: [${errorDetail}]` }
  );
}

export default async function requestAnswer(
  data: AnswerRequest
): Promise<Throwable<AnswerResponse>> {
  // URL: /chatbot/ask POST
  // body:
  //  'itemNumberId', number
  //  'question', string
  //  'recaptchaToken', string
  const url = new URL(`/chatbot/ask`, window.location.origin);
  try {
    const response = await fetch(url.href, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw await getErrorFromResponse(response);
    }
    const result = await response.json<AnswerResponse>();
    return { isError: false, value: result };
  } catch (error) {
    return { isError: true, error: toError(error) };
  }
}
